export function postJumpTo(container = document) {
  let jumpTo = container.querySelectorAll('.jump-to-link');
  for (let jumpToElement of jumpTo) {
    const target = jumpToElement.getAttribute('href'),
        targetElm = container.querySelector(target),
    offset = 100;
    jumpToElement?.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: window.scrollY + targetElm.getBoundingClientRect().top - offset,
        behavior: 'smooth'
      })
    })
  }
}